import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateCropExplorationEntry, updateCropExplorationTemplateEntry } from "services";

import { GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES, UPDATE_CROP_EXPLORATION_ENTRY } from "consts";

export const useUpdateCropExplorationEntry = (isAdmin: boolean = false) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_CROP_EXPLORATION_ENTRY],
    mutationFn: !isAdmin ? updateCropExplorationEntry : updateCropExplorationTemplateEntry,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] });
    },
  });
};
